import moment from 'moment';

const formatMonth = (m, f = 'MM') =>
  moment()
    .month(m)
    .format(f);

const getMonths = () => {
  const monthOptions = Array.apply(null, { length: 12 }).map((_, i) => ({
    key: i,
    value: formatMonth(i, 'MMMM'),
    label: formatMonth(i, 'MMMM'),
  }));
  monthOptions.unshift({ key: 'default', value: '', label: '' });
  return monthOptions;
};

const getDays = () => {
  const daysOptions = Array.apply(null, { length: 31 }).map((_, i) => ({
    key: i + 1,
    value: i + 1,
    label: i + 1,
  }));
  daysOptions.unshift({ key: 'default', value: '', label: '' });
  return daysOptions;
};

export { formatMonth, getDays, getMonths };
